import React from 'react';

import { ManageContactsList } from '../ManageContactsList/ManageContactsList';
import { ManageContactForm } from '../ManageContactForm/ManageContactForm';

import {
  ManageContactsWrapper,
  ManageContactsLeft,
  ManageContactsRight,
} from './ManageContactsViewStyles';

export const ManageContactsView = () => {
  return (
    <ManageContactsWrapper data-test="MANAGE_CONTACTS">
      <ManageContactsLeft>
        <ManageContactsList />
      </ManageContactsLeft>
      <ManageContactsRight>
        <ManageContactForm />
      </ManageContactsRight>
    </ManageContactsWrapper>
  );
};
